/* naawm / Nox — grille bénéfices : overlay flouté + navigation (~1 Ko) */
(function () {
  if (window.__noxFeat) return;
  window.__noxFeat = true;

  function init() {
    document.querySelectorAll('[data-nox-feat]:not(.nox-feat-armed)').forEach(function (root) {
      root.classList.add('nox-feat-armed');
      var cards = [].slice.call(root.querySelectorAll('[data-nox-feat-open]'));
      var modal = root.querySelector('[data-nox-feat-modal]');
      if (!cards.length || !modal) return;

      var img = modal.querySelector('[data-feat-modal-img]');
      var label = modal.querySelector('[data-feat-modal-label]');
      var title = modal.querySelector('[data-feat-modal-title]');
      var text = modal.querySelector('[data-feat-modal-text]');
      var current = 0;

      function render(i) {
        current = (i + cards.length) % cards.length;
        var c = cards[current];
        var cardImg = c.querySelector('.nox-feat__img');
        img.src = cardImg ? cardImg.currentSrc || cardImg.src : '';
        img.alt = c.dataset.featTitle || '';
        label.textContent = c.dataset.featLabel || '';
        title.textContent = c.dataset.featTitle || '';
        text.textContent = c.dataset.featText || '';
      }

      function open(i) {
        render(i);
        modal.hidden = false;
        document.documentElement.style.overflow = 'hidden';
        void modal.offsetHeight;
        modal.classList.add('is-open');
      }

      function close() {
        modal.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        setTimeout(function () {
          modal.hidden = true;
        }, 220);
      }

      cards.forEach(function (c, i) {
        c.addEventListener('click', function () {
          open(i);
        });
      });
      modal.querySelectorAll('[data-nox-feat-close]').forEach(function (b) {
        b.addEventListener('click', close);
      });
      var prev = modal.querySelector('[data-nox-feat-prev]');
      if (prev) prev.addEventListener('click', function () {
        render(current - 1);
      });
      var next = modal.querySelector('[data-nox-feat-next]');
      if (next) next.addEventListener('click', function () {
        render(current + 1);
      });
      document.addEventListener('keydown', function (e) {
        if (modal.hidden) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') render(current - 1);
        if (e.key === 'ArrowRight') render(current + 1);
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
